webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadImage = loadImage;
exports.loadSvg = loadSvg;
function loadImage(src) {
    return new Promise(function (resolve) {
        var image = document.createElement('img');
        image.src = src;

        if (image.complete && image.naturalWidth) {
            resolve(image);
        } else {
            image.addEventListener('load', function () {
                return resolve(image);
            });
        }
    });
}

function loadSvg(src) {
    return new Promise(function (resolve, reject) {
        fetch(src).then(function (response) {
            if (response.ok && response.headers.get('Content-Type') === 'image/svg+xml') {
                return response.text();
            }

            reject(response.status);
            return null;
        }).then(function (text) {
            var parser = new DOMParser();
            var svg = parser.parseFromString(text, 'image/svg+xml').querySelector('svg');
            resolve(svg);
        });
    });
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(7);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import _ from 'lodash'
_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
    state: {},
    mutations: {}
});

exports.default = store;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(14);

var _store = __webpack_require__(8);

var _store2 = _interopRequireDefault(_store);

var _components = __webpack_require__(15);

var components = _interopRequireWildcard(_components);

var _mquery = __webpack_require__(71);

var mediaquery = _interopRequireWildcard(_mquery);

__webpack_require__(72);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mediaqueries

mediaquery.add({
    mediaquery: '(max-width: 768px)',
    name: 'small'
});

mediaquery.add({
    mediaquery: '(min-width: 769px) and (max-width: 1024px)',
    name: 'medium'
});

mediaquery.add({
    mediaquery: '(min-width: 1025px) and (max-width: 1440px)',
    name: 'large'
});

mediaquery.add({
    mediaquery: '(min-width: 1441px)',
    name: 'wide'
});

window.theme = {
    modules: {
        components: components
    },
    store: _store2.default,
    mediaquery: mediaquery

    // init components
};_lodash2.default.each(theme.modules, function (module) {
    if (_lodash2.default.isFunction(module.initialize)) {
        module.initialize(theme);
    }
});

// ready components
Promise.resolve().then(function () {
    return new Promise(function (resolve) {
        if (document.readyState === 'loading') {
            document.addEventListener('readystatechange', function () {
                return resolve();
            });
            return;
        } else {
            resolve();
        }
    });
}).then(function () {
    _lodash2.default.each(theme.modules, function (module) {
        if (_lodash2.default.isFunction(module.ready)) {
            module.ready(theme);
        }
    });
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__.p = window.__themeUrl + "/dist/";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = exports.instances = undefined;
exports.initialize = initialize;
exports.ready = ready;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(16);

var _store = __webpack_require__(8);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentEl = null;

var instances = exports.instances = [];

var config = exports.config = {
    contentSelector: '.content',
    componentAttribute: 'data-component',
    componentId: 'data-id'
};

function initialize(mtwp) {
    _lodash2.default.defer(function () {
        if (mtwp.modules.pageLoader) {
            // destroy and remove components before content replacement
            mtwp.modules.pageLoader.config.hooks.beforeContentReplace.push(function () {
                return onBeforeContentReplace();
            });
            // parse components after page loader content replacement
            mtwp.modules.pageLoader.config.hooks.afterContentReplace.push(function () {
                return parse();
            });
        }
    });
}

function ready(mtwp) {
    contentEl = document.querySelector(config.contentSelector);
    parse();
}

function onBeforeContentReplace() {
    // destroy and remove content components
    _lodash2.default.each(_lodash2.default.filter(instances, function (component) {
        return component.scope === 'content';
    }), function (component) {
        component.$destroy();
        exports.instances = instances = _lodash2.default.without(instances, component);
    });
}

function parse() {
    var componentsEls = document.querySelectorAll('[' + config.componentAttribute + ']');
    _lodash2.default.each(componentsEls, function (el) {
        var componentName = _lodash2.default.kebabCase(el.getAttribute(config.componentAttribute));
        (0, _index.importComponent)(componentName).then(function (componentObject) {
            // quit if no component is found
            if (!componentObject) {
                return;
            }

            componentObject = _lodash2.default.cloneDeep(componentObject);

            // test if component is global or not
            var scope = 'global';
            var parentEl = el;

            while (parentEl && parentEl.parentNode) {
                if (parentEl === contentEl) {
                    scope = 'content';
                    parentEl = null;
                } else {
                    parentEl = parentEl.parentNode;
                }
            }

            // add store to the vue instance
            componentObject.store = _store2.default;

            // extend data object
            if (_lodash2.default.isPlainObject(componentObject.data)) {
                componentObject.data = _lodash2.default.assign(componentObject.data, { scope: scope });
            } else {
                componentObject.data = { scope: scope };
            }

            // set data & remove window object
            var componentId = el.getAttribute(config.componentId);
            if (window['__' + componentId]) {
                componentObject.data = _lodash2.default.assign(componentObject.data, window['__' + componentId]);
                delete window['__' + componentId];
            }

            // remove data script
            var dataScript = el.parentNode.querySelector('#data-' + componentId);
            if (dataScript) {
                dataScript.parentNode.removeChild(dataScript);
            }

            // set template
            componentObject.template = nodeToVueTemplate(el);

            // create component and then mount the element
            var componentInstance = new _vue2.default(componentObject);
            componentInstance.$mount(el);

            // remove component attribute / id
            componentInstance.$el.removeAttribute(config.componentAttribute);
            componentInstance.$el.removeAttribute(config.componentId);

            // add the instance to the set
            instances.push(componentInstance);
        }).catch(function (str) {
            return console.error(str);
        });
    });
}

function nodeToVueTemplate(el) {
    var elCopy = el.cloneNode(true);
    replaceAttributesToVueTemplate(elCopy);
    return elCopy.outerHTML.replace(/\s\s+/g, ' ');
}

function replaceAttributesToVueTemplate(el) {
    // replace attributes
    if (el.hasAttributes()) {
        for (var i = el.attributes.length - 1; i >= 0; i--) {
            var attrName = el.attributes[i].name.toLowerCase();
            var attrValue = el.attributes[i].value;
            var vueAttributeName = null;

            // other directives
            switch (attrName) {
                case 'data-html':
                    vueAttributeName = 'v-html';
                    break;

                case 'data-text':
                    vueAttributeName = 'v-text';
                    break;

                case 'data-show':
                    vueAttributeName = 'v-show';
                    break;

                case 'data-if':
                    vueAttributeName = 'v-if';
                    break;

                case 'data-else':
                    vueAttributeName = 'v-else';
                    break;

                case 'data-else-if':
                    vueAttributeName = 'v-else-if';
                    break;

                case 'data-for':
                    vueAttributeName = 'v-for';
                    break;

                case 'data-model':
                    vueAttributeName = 'v-model';
                    break;

                case 'data-pre':
                    vueAttributeName = 'v-pre';
                    break;

                case 'data-cloak':
                    vueAttributeName = 'v-cloak';
                    break;

                case 'data-once':
                    vueAttributeName = 'v-once';
                    break;

                case 'data-ref':
                    vueAttributeName = 'ref';
                    break;
            }

            // bind directive
            if (!vueAttributeName) {
                var bindMatch = attrName.match(/^data\-bind\-(.+)$/);
                if (bindMatch && bindMatch[1]) {
                    vueAttributeName = 'v-bind:' + bindMatch[1];
                }
            }

            // on directive
            if (!vueAttributeName) {
                var onMatch = attrName.match(/^data\-on\-(.+)$/);
                if (onMatch && onMatch[1]) {
                    vueAttributeName = 'v-on:' + onMatch[1];
                }
            }

            // asssign attribute
            if (vueAttributeName) {
                el.removeAttribute(attrName);
                el.setAttribute(vueAttributeName, attrValue);
            }
        }
    }

    // recursively convert children attributes
    if (el.children.length) {
        for (var _i = el.children.length - 1; _i >= 0; _i--) {
            replaceAttributesToVueTemplate(el.children[_i]);
        }
    }
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.importComponent = importComponent;

var _alternateBoxes = __webpack_require__(17);

var _alternateBoxes2 = _interopRequireDefault(_alternateBoxes);

var _aboutBox = __webpack_require__(19);

var _aboutBox2 = _interopRequireDefault(_aboutBox);

var _aboutMap = __webpack_require__(21);

var _aboutMap2 = _interopRequireDefault(_aboutMap);

var _contactsContent = __webpack_require__(23);

var _contactsContent2 = _interopRequireDefault(_contactsContent);

var _downloadBox = __webpack_require__(25);

var _downloadBox2 = _interopRequireDefault(_downloadBox);

var _featureSlider = __webpack_require__(27);

var _featureSlider2 = _interopRequireDefault(_featureSlider);

var _floatBanner = __webpack_require__(29);

var _floatBanner2 = _interopRequireDefault(_floatBanner);

var _footer = __webpack_require__(31);

var _footer2 = _interopRequireDefault(_footer);

var _fullSlider = __webpack_require__(33);

var _fullSlider2 = _interopRequireDefault(_fullSlider);

var _gallerySlider = __webpack_require__(36);

var _gallerySlider2 = _interopRequireDefault(_gallerySlider);

var _infoBox = __webpack_require__(38);

var _infoBox2 = _interopRequireDefault(_infoBox);

var _infoCertifications = __webpack_require__(39);

var _infoCertifications2 = _interopRequireDefault(_infoCertifications);

var _infoImages = __webpack_require__(41);

var _infoImages2 = _interopRequireDefault(_infoImages);

var _mobileNav = __webpack_require__(43);

var _mobileNav2 = _interopRequireDefault(_mobileNav);

var _modalForm = __webpack_require__(45);

var _modalForm2 = _interopRequireDefault(_modalForm);

var _numbers = __webpack_require__(47);

var _numbers2 = _interopRequireDefault(_numbers);

var _productTypesList = __webpack_require__(50);

var _productTypesList2 = _interopRequireDefault(_productTypesList);

var _pageContent = __webpack_require__(51);

var _pageContent2 = _interopRequireDefault(_pageContent);

var _postContent = __webpack_require__(53);

var _postContent2 = _interopRequireDefault(_postContent);

var _postsList = __webpack_require__(55);

var _postsList2 = _interopRequireDefault(_postsList);

var _postsSlider = __webpack_require__(57);

var _postsSlider2 = _interopRequireDefault(_postsSlider);

var _sidebarContent = __webpack_require__(59);

var _sidebarContent2 = _interopRequireDefault(_sidebarContent);

var _socialBar = __webpack_require__(61);

var _socialBar2 = _interopRequireDefault(_socialBar);

var _timelineSlider = __webpack_require__(63);

var _timelineSlider2 = _interopRequireDefault(_timelineSlider);

var _top = __webpack_require__(65);

var _top2 = _interopRequireDefault(_top);

var _topPage = __webpack_require__(67);

var _topPage2 = _interopRequireDefault(_topPage);

var _verticalBoxes = __webpack_require__(69);

var _verticalBoxes2 = _interopRequireDefault(_verticalBoxes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function importComponent(name) {
    var components = {
        'about-box': _aboutBox2.default,
        'alternate-boxes': _alternateBoxes2.default,
        'about-map': _aboutMap2.default,
        'contacts-content': _contactsContent2.default,
        'download-box': _downloadBox2.default,
        'feature-slider': _featureSlider2.default,
        'float-banner': _floatBanner2.default,
        'footer': _footer2.default,
        'full-slider': _fullSlider2.default,
        'gallery-slider': _gallerySlider2.default,
        'info-box': _infoBox2.default,
        'mobile-nav': _mobileNav2.default,
        'modal-form': _modalForm2.default,
        'numbers': _numbers2.default,
        'product-types-list': _productTypesList2.default,
        'posts-slider': _postsSlider2.default,
        'social-bar': _socialBar2.default,
        'timeline-slider': _timelineSlider2.default,
        'top': _top2.default,
        'vertical-boxes': _verticalBoxes2.default
    };

    return components[name] ? Promise.resolve(components[name]) : Promise.reject('no component found');
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(18);

var _image = __webpack_require__(1);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'alternate-boxes',

    data: {
        iconsSvg: [],
        observer: null
    },

    mounted: function mounted() {
        var _this = this;

        this.loadIcons();

        this.observer = new IntersectionObserver(function (entries) {
            _lodash2.default.each(entries, function (entry) {
                if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
                    entry.target.classList.remove('hidden');
                }
            });
        }, {
            rootMargin: '-10%'
        });
        _lodash2.default.each(this.$el.querySelectorAll('.alternate-boxes__box'), function (el) {
            return _this.observer.observe(el);
        });
    },


    methods: {
        loadIcons: function loadIcons() {
            var _this2 = this;

            this.icons.forEach(function (url, i) {
                if (url) {
                    (0, _image.loadSvg)(url).then(function (svg) {
                        var cloneIconsSvg = _lodash2.default.clone(_this2.iconsSvg);
                        cloneIconsSvg[i] = svg.outerHTML;
                        _this2.iconsSvg = cloneIconsSvg;
                    });
                }
            });
        }
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(20);

exports.default = {
    name: 'about-box',

    data: {
        observer: null
    },

    mounted: function mounted() {
        this.observer = new IntersectionObserver(function (entries) {
            _.each(entries, function (entry) {
                if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
                    entry.target.classList.remove('hidden');
                }
            });
        }, {
            rootMargin: '-10%'
        });

        this.observer.observe(this.$el);
    }
};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(22);

exports.default = {
    name: 'about-map',

    data: {
        observer: null
    },

    mounted: function mounted() {
        this.googleMap();

        this.observer = new IntersectionObserver(function (entries) {
            _.each(entries, function (entry) {
                if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
                    entry.target.classList.remove('hidden');
                }
            });
        }, {
            rootMargin: '-10%'
        });

        this.observer.observe(this.$el);
    },


    methods: {
        googleMap: function googleMap() {
            var _this = this;

            if (!window.google) {
                setTimeout(function () {
                    return _this.googleMap();
                }, 1000);
                return;
            }

            if (!this.$refs.map) {
                return;
            }

            var position = {
                lat: parseFloat(this.position.lat),
                lng: parseFloat(this.position.lng)
            };

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 12,
                styles: [{
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#6195a0"
                    }]
                }, {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{
                        "color": "#f2f2f2"
                    }]
                }, {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#ffffff"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#e6f3d6"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [{
                        "saturation": -100
                    }, {
                        "lightness": 45
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#f4d2c5"
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text",
                    "stylers": [{
                        "color": "#4e4e4e"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#f4f4f4"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#787878"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{
                        "color": "#eaf6f8"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#eaf6f8"
                    }]
                }]
            });

            // icon
            var icon = {
                url: window.__themeUrl + '/assets/img/marker.png',
                scaledSize: {
                    width: 150,
                    height: 169
                }
            };

            new google.maps.Marker({
                position: position,
                map: this.map,
                icon: icon
            });
        }
    }
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(24);

exports.default = {
    name: 'contacts-content',

    mounted: function mounted() {
        this.googleMap();

        var radioIndex = sessionStorage.getItem('contactFormIndex');
        if (radioIndex) {
            radioIndex = parseInt(radioIndex) - 1;
            sessionStorage.removeItem('contactFormIndex');
            var radios = this.$el.querySelectorAll('.communication-type input[type="radio"]');
            if (radios.length && radios[radioIndex]) {
                radios[radioIndex].checked = true;
            }
        }
    },


    methods: {
        googleMap: function googleMap() {
            var _this = this;

            if (!window.google) {
                setTimeout(function () {
                    return _this.googleMap();
                }, 1000);
                return;
            }

            var position = {
                lat: parseFloat(this.position.lat),
                lng: parseFloat(this.position.lng)
            };

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 12,
                styles: [{
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#6195a0"
                    }]
                }, {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{
                        "color": "#f2f2f2"
                    }]
                }, {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#ffffff"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#e6f3d6"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [{
                        "saturation": -100
                    }, {
                        "lightness": 45
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#f4d2c5"
                    }, {
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text",
                    "stylers": [{
                        "color": "#4e4e4e"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#f4f4f4"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#787878"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{
                        "color": "#eaf6f8"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#eaf6f8"
                    }]
                }]
            });

            var icon = {
                url: window.__themeUrl + '/assets/img/marker.png',
                scaledSize: {
                    width: 150,
                    height: 169
                }
            };

            new google.maps.Marker({
                position: position,
                map: this.map,
                icon: icon
            });
        }
    }
};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(26);

var _eventBus = __webpack_require__(2);

exports.default = {
    name: 'download-box',

    mounted: function mounted() {},


    methods: {
        submit: function submit() {
            _eventBus.EventBus.$emit('ModalForm.toggle', 'newsletter');
        }
    }
};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(28);

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'feature-slider',

    data: {
        index: 0,
        interactions: true,
        state: 'in' // in, out
    },

    computed: {
        currentSlide: function currentSlide() {
            if (this.slides && this.slides.length && this.slides[this.index]) {
                return this.slides[this.index];
            } else {
                return null;
            }
        },
        nextIndex: function nextIndex() {
            var nextIndex = this.index + 1 === this.slides.length ? 0 : this.index + 1;
            return nextIndex !== this.index ? nextIndex : null;
        }
    },

    methods: {
        toggleSlide: function toggleSlide(i) {
            var _this = this;

            if (!this.interactions) {
                return;
            }
            if (i === this.index) {
                return;
            }

            this.interactions = false;

            Promise.resolve().then(function () {
                return new Promise(function (resolve) {
                    _this.state = 'out';
                    setTimeout(function () {
                        return resolve();
                    }, 550);
                });
            }).then(function () {
                return new Promise(function (resolve) {
                    _this.index = i;
                    _vue2.default.nextTick(function () {
                        return resolve();
                    });
                });
            }).then(function () {
                return new Promise(function (resolve) {
                    _this.state = 'in';
                    setTimeout(function () {
                        return resolve();
                    }, 550);
                });
            }).then(function () {
                _this.interactions = true;
            });
        }
    }
};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(30);

var _eventBus = __webpack_require__(2);

exports.default = {
    name: 'float-banner',

    data: {
        display: 'hidden'
    },

    mounted: function mounted() {
        var sessionBannerDisplay = sessionStorage.getItem('coopBannerDisplay');
        if (['visible', 'hidden'].includes(sessionBannerDisplay)) {
            this.display = sessionBannerDisplay;
        } else {
            this.display = 'visible';
        }
    },


    methods: {
        close: function close() {
            this.display = 'hidden';
            sessionStorage.setItem('coopBannerDisplay', 'hidden');
        }
    }
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(32);

var _eventBus = __webpack_require__(2);

exports.default = {
    name: 'footer',

    methods: {
        loginForm: function loginForm(form) {
            _eventBus.EventBus.$emit('ModalForm.toggle', form);
        }
    }
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(34);

var _fullSliderTween = __webpack_require__(35);

var _image = __webpack_require__(1);

exports.default = {
    name: 'full-slider',

    data: {
        index: 0,
        interactions: true,
        smallTitleHidden: false,
        titleHidden: false,
        slideTimeout: null
    },

    computed: {
        currentSlide: function currentSlide() {
            if (this.slides && this.slides.length) {
                return this.slides[this.index];
            } else {
                return null;
            }
        }
    },

    mounted: function mounted() {
        this.toggleSlideTimeout();
    },


    methods: {
        toggleSlideTimeout: function toggleSlideTimeout() {
            var _this = this;

            clearTimeout(this.slideTimeout);
            this.slideTimeout = setTimeout(function () {
                if (_this.slides && _this.slides.length) {
                    var nextIndex = _this.index + 1 === _this.slides.length ? 0 : _this.index + 1;
                    _this.toggleSlide(nextIndex);
                }
            }, 5000);
        },
        toggleSlide: function toggleSlide(i) {
            var _this2 = this;

            if (i === this.index) {
                return;
            }
            if (!this.interactions) {
                return;
            }

            clearTimeout(this.slideTimeout);
            this.interactions = false;
            var imageUrl = this.slides[i].image ? this.slides[i].image.sizes.wide : null;

            Promise.resolve().then(function () {
                return _fullSliderTween.slideOut.call(_this2);
            }).then(function () {
                _this2.index = i;
                return imageUrl ? (0, _image.loadImage)(imageUrl) : Promise.resolve();
            }).then(function () {
                return _fullSliderTween.slideIn.call(_this2);
            }).then(function () {
                _this2.interactions = true;
                _this2.toggleSlideTimeout();
            });
        }
    }
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slideOut = slideOut;
exports.slideIn = slideIn;

var _animejs = __webpack_require__(5);

var _animejs2 = _interopRequireDefault(_animejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function slideOut() {
    var timeline = _animejs2.default.timeline();

    timeline.add({
        targets: this.$refs.overlayLoader,
        scaleX: [0, 1],
        opacity: [0, 1],
        duration: 700,
        easing: 'easeInOutQuint',
        offset: 0
    });

    return timeline.finished;
}

function slideIn() {
    var _this = this;

    var timeline = _animejs2.default.timeline();

    this.$refs.overlayLoader.style.transformOrigin = '0% 50%';
    this.smallTitleHidden = true;
    this.titleHidden = true;

    timeline.add({
        targets: this.$refs.overlayLoader,
        scaleX: [1, 0],
        duration: 700,
        easing: 'easeInOutQuint',
        offset: 0
    });

    timeline.finished.then(function () {
        _this.$refs.overlayLoader.style.transformOrigin = null;
        _this.$refs.overlayLoader.style.transform = null;
        _this.smallTitleHidden = false;
        _this.titleHidden = false;
    });

    return timeline.finished;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(37);

exports.default = {
    name: 'gallery-slider',

    data: {
        index: 0,
        imagesDisplay: 4,
        size: 'full',
        timeout: null
    },

    computed: {
        barWidth: function barWidth() {
            return 100 / this.imagesDisplay * this.images.length + '%';
        },
        barTranslate: function barTranslate() {
            return 'translateX(' + 100 / this.images.length * this.index * -1 + '%)';
        }
    },

    mounted: function mounted() {
        var _this = this;

        if (this.size === 'full') {
            var mqSmall = _.find(window.theme.mediaquery.get(), function (mqObj) {
                return mqObj.name === 'small';
            });
            var mqMedium = _.find(window.theme.mediaquery.get(), function (mqObj) {
                return mqObj.name === 'medium';
            });
            var mqLarge = _.find(window.theme.mediaquery.get(), function (mqObj) {
                return mqObj.name === 'large';
            });
            var mqWide = _.find(window.theme.mediaquery.get(), function (mqObj) {
                return mqObj.name === 'wide';
            });

            mqSmall.mql.addListener(function (e) {
                if (e.matches) {
                    _this.imagesDisplay = 1;
                }
            });
            mqMedium.mql.addListener(function (e) {
                if (e.matches) {
                    _this.imagesDisplay = 2;
                }
            });
            mqLarge.mql.addListener(function (e) {
                if (e.matches) {
                    _this.imagesDisplay = 4;
                }
            });
            mqWide.mql.addListener(function (e) {
                if (e.matches) {
                    _this.imagesDisplay = 4;
                }
            });

            if (mqSmall.mql.matches) {
                this.imagesDisplay = 1;
            }
            if (mqMedium.mql.matches) {
                this.imagesDisplay = 2;
            }
            if (mqLarge.mql.matches) {
                this.imagesDisplay = 4;
            }
            if (mqWide.mql.matches) {
                this.imagesDisplay = 4;
            }
        }

        if (this.size === 'small') {
            this.imagesDisplay = 1;
        }

        // set gallery
        lightGallery(this.$refs.bar);

        // set timeout
        this.setTimeout();
    },


    methods: {
        setTimeout: function (_setTimeout) {
            function setTimeout() {
                return _setTimeout.apply(this, arguments);
            }

            setTimeout.toString = function () {
                return _setTimeout.toString();
            };

            return setTimeout;
        }(function () {
            var _this2 = this;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                _this2.index = _this2.index + 1 === _this2.images.length - _this2.imagesDisplay + 1 ? 0 : _this2.index + 1;
                _this2.setTimeout();
            }, 5000);
        }),
        next: function next() {
            this.index = this.index + 1 === this.images.length - this.imagesDisplay + 1 ? this.index : this.index + 1;
            this.setTimeout();
        },
        prev: function prev() {
            this.index = this.index - 1 < 0 ? this.index : this.index - 1;
            this.setTimeout();
        }
    }
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _image = __webpack_require__(1);

exports.default = {
    name: 'info-box',

    data: {
        isconSvg: null
    },

    mounted: function mounted() {
        var _this = this;

        if (this.icon_url) {
            (0, _image.loadSvg)(this.icon_url).then(function (svg) {
                return _this.isconSvg = svg.outerHTML;
            });
        }
        if (this.contact_fom_index && this.$refs.button) {
            this.$refs.button.addEventListener('click', function (e) {
                sessionStorage.setItem('contactFormIndex', _this.contact_fom_index);
            });
        }
    }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(40);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(42);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(44);

var _eventBus = __webpack_require__(2);

exports.default = {
    name: 'mobile-nav',

    data: {
        visibility: 'hidden'
    },

    mounted: function mounted() {
        var _this = this;

        this.$el.classList.remove('hidden');
        _eventBus.EventBus.$on('MobileMenu.toggle', function () {
            return _this.toggle();
        });
    },


    methods: {
        toggle: function toggle() {
            this.visibility = this.visibility === 'hidden' ? 'visible' : 'hidden';
        }
    }
};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(46);

var _eventBus = __webpack_require__(2);

exports.default = {
    name: 'modal-form',

    data: {
        display: false,
        form: null
    },

    mounted: function mounted() {
        var _this = this;

        _eventBus.EventBus.$on('ModalForm.toggle', function (form) {
            if (!_this.display) {
                _this.form = form;
                _this.toggleDisplay();
            }
        });

        var certificateButton = document.querySelector('.button--login-certificate');
        if (certificateButton) {
            certificateButton.addEventListener('click', function () {
                return _eventBus.EventBus.$emit('ModalForm.toggle', 'certificate');
            });
        }
    },


    methods: {
        toggleDisplay: function toggleDisplay() {
            this.display = !this.display;
        }
    }
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(48);

var _image = __webpack_require__(1);

var _numbersTweens = __webpack_require__(49);

exports.default = {
    name: 'numbers',

    data: {
        intObserver: null,
        tweenComplete: true
    },

    mounted: function mounted() {
        var _this = this;

        this.loadIcons();

        this.intObserver = new IntersectionObserver(function (entries) {
            if (entries && entries.length) {
                if (entries[0].isIntersecting) {
                    _this.tweenNumbers();
                }
            }
        });
        this.intObserver.observe(this.$el);
    },


    methods: {
        loadIcons: function loadIcons() {
            if (this.numbers && this.numbers.length) {
                this.numbers.forEach(function (number) {
                    if (number.icon) {
                        Promise.resolve().then(function () {
                            return (0, _image.loadSvg)(number.icon);
                        }).then(function (svg) {
                            number.icon_html = svg.outerHTML;
                        });
                    }
                });
            }
        },
        tweenNumbers: function tweenNumbers() {
            var _this2 = this;

            if (!this.tweenComplete) {
                return;
            }
            if (this.numbers && this.numbers.length) {
                var tweens = this.numbers.map(function (number) {
                    return _numbersTweens.tweenNumbers.call(_this2, number);
                });
                this.tweenComplete = false;
                Promise.all(tweens).then(function () {
                    _this2.tweenComplete = true;
                });
            }
        }
    }
};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tweenNumbers = tweenNumbers;

var _animejs = __webpack_require__(5);

var _animejs2 = _interopRequireDefault(_animejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tweenNumbers(number) {
    var timeline = _animejs2.default.timeline();
    var obj = { value: 0 };
    var finalValue = number.number;

    return (0, _animejs2.default)({
        targets: obj,
        value: [0, finalValue],
        duration: 1500,
        easing: 'easeOutQuart',
        update: function update() {
            return requestAnimationFrame(function () {
                number.number = Math.round(obj.value);
            });
        }
    }).finished;
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

var _image = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'product-types-list',

    data: {
        observer: null
    },

    mounted: function mounted() {
        var _this = this;

        this.loadSvg();

        this.observer = new IntersectionObserver(function (entries) {
            _lodash2.default.each(entries, function (entry) {
                if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
                    entry.target.classList.remove('hidden');
                }
            });
        }, {
            rootMargin: '-10%'
        });

        _lodash2.default.each(this.$el.querySelectorAll('.alternate-boxes__box'), function (el) {
            return _this.observer.observe(el);
        });
    },


    methods: {
        loadSvg: function loadSvg() {
            var els = this.$el.querySelectorAll('[data-icon-url]');
            _lodash2.default.each(els, function (el) {
                (0, _image.loadSvg)(el.getAttribute('data-icon-url')).then(function (svg) {
                    el.appendChild(svg);
                });
            });
        }
    }
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(52);

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(54);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(56);

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(58);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'posts-slider',

    data: {
        index: 0
    },

    computed: {
        isMobile: function isMobile() {
            var mqSet = window.theme.mediaquery.get();
            var mqSmall = _lodash2.default.find(mqSet, function (mqObj) {
                return mqObj.name === 'small';
            });
            var mqMedium = _lodash2.default.find(mqSet, function (mqObj) {
                return mqObj.name === 'medium';
            });
            return mqSmall.mql.matches || mqMedium.mql.matches;
        },
        sliderWidth: function sliderWidth() {
            if (this.isMobile) {
                return 100 * this.posts.length + '%';
            } else {
                if (this.posts && this.posts.length) {
                    return 100 / 3 * this.posts.length + '%';
                } else {
                    return '100%';
                }
            }
        },
        sliderTransform: function sliderTransform() {
            if (this.posts && this.posts.length) {
                return 'translateX(' + 100 / this.posts.length * -this.index + '%)';
            } else {
                return 'none';
            }
        }
    }
};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(60);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(62);

var _image = __webpack_require__(1);

exports.default = {
    name: 'social-bar',

    mounted: function mounted() {
        this.loadSvg();
    },


    methods: {
        loadSvg: function loadSvg() {
            this.socialsLeft.forEach(function (social) {
                var url = window.__themeUrl + '/assets/svg/socials/' + social.social_icon;
                (0, _image.loadSvg)(url).then(function (svg) {
                    return social.icon = svg.outerHTML;
                });
            });
            this.socialsRight.forEach(function (social) {
                var url = window.__themeUrl + '/assets/svg/socials/' + social.social_icon;
                (0, _image.loadSvg)(url).then(function (svg) {
                    return social.icon = svg.outerHTML;
                });
            });
        }
    }
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(64);

var _image = __webpack_require__(1);

exports.default = {
    name: 'timeline-slider',

    data: {
        index: 0,
        timeout: null
    },

    computed: {
        sliderTransform: function sliderTransform() {
            if (this.items && this.items.length) {
                return 'translateX(' + 100 / this.items.length * -this.index + '%)';
            } else {
                return 'none';
            }
        }
    },

    watch: {
        index: function index() {
            this.sliderTimeout();
        }
    },

    mounted: function mounted() {
        this.loadIcons();
        this.sliderTimeout();
    },


    methods: {
        loadIcons: function loadIcons() {
            this.items.forEach(function (item) {
                if (item.icon_url) {
                    (0, _image.loadSvg)(item.icon_url).then(function (svg) {
                        return item.icon_svg = svg.outerHTML;
                    });
                }
            });
        },
        next: function next() {
            if (this.index + 1 === this.items.length) {
                return;
            } else {
                this.index++;
            }
        },
        prev: function prev() {
            if (this.index - 1 < 0) {
                return;
            } else {
                this.index--;
            }
        },
        sliderTimeout: function sliderTimeout() {
            var _this = this;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                if (_this.index + 1 === _this.items.length) {
                    _this.index = 0;
                } else {
                    _this.index++;
                }
            }, 8000);
        }
    }
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(66);

var _eventBus = __webpack_require__(2);

exports.default = {
    name: 'top',

    data: {
        intObserver: null,
        position: 'top'
    },

    mounted: function mounted() {
        var _this = this;

        var placeholder = document.querySelector('.top__placeholder');
        this.intObserver = new IntersectionObserver(function (entries) {
            if (entries && entries.length) {
                if (entries[0].isIntersecting && _this.position !== 'top') {
                    _this.position = 'top';
                }
                if (!entries[0].isIntersecting && _this.position !== 'fixed') {
                    _this.position = 'fixed';
                }
            }
        });
        this.intObserver.observe(placeholder);
    },


    methods: {
        toggleMobileNav: function toggleMobileNav() {
            _eventBus.EventBus.$emit('MobileMenu.toggle');
        }
    }
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(68);

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(70);

var _image = __webpack_require__(1);

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'vertical-boxes',

    data: {
        iconsSvg: []
    },

    mounted: function mounted() {
        this.loadIcons();
    },


    methods: {
        loadIcons: function loadIcons() {
            var _this = this;

            this.icons.forEach(function (url, i) {
                if (url) {
                    (0, _image.loadSvg)(url).then(function (svg) {
                        var cloneIconsSvg = _lodash2.default.clone(_this.iconsSvg);
                        cloneIconsSvg[i] = svg.outerHTML;
                        _this.iconsSvg = cloneIconsSvg;
                    });
                }
            });
        }
    }
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add = add;
exports.remove = remove;
exports.get = get;

var _lodash = __webpack_require__(0);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mqSet = [];

function add(params) {
    if (!(params && params.mediaquery)) {
        return;
    }
    if (!(params && params.name)) {
        return;
    }

    var mql = window.matchMedia(params.mediaquery);
    var className = 'mq-' + _lodash2.default.kebabCase(params.name);
    var mqObj = {
        mql: mql,
        name: params.name,
        listener: function listener() {
            window.document.body.classList[mql.matches ? 'add' : 'remove'](className);
        }
    };

    mqObj.listener();
    mql.addListener(mqObj.listener);
    mqSet.push(mqObj);
}

function remove(name) {
    var removed = _lodash2.default.remove(mqSet, function (mqObj) {
        return mqObj.name === name;
    });
    if (removed.length) {
        _lodash2.default.each(removed, function (mqObj) {
            mqObj.mql.removeListener(mqObj.listener);
        });
    }
    return !!removed.length;
}

function get() {
    return mqSet;
}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[13]);


// WEBPACK FOOTER //
// app.js